import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import _ from 'lodash';
import TermsText from '../../TermsText/TermsText';
import './IncentivesAsideContent.less';

const LOCALE_PREFIX = 'US/components/AsideContent/AsideContent';

export class IncentivesAsideContent extends Component {

    static propTypes = {
        intl: intlShape.isRequired,
        imgElt: PropTypes.element,
        incentivesDetails: PropTypes.shape({
            headline_text: PropTypes.string,
            offer_text_1: PropTypes.string,
            offer_text_2: PropTypes.string,
            terms_link: PropTypes.string,
            terms_text: PropTypes.string,
            terms_link_text: PropTypes.string
        })
    };

    render() {
        const { imgElt, incentivesDetails, intl } = this.props;
        const headlineText = _.get(incentivesDetails, 'headline_text');
        const offerText1 = _.get(incentivesDetails, 'offer_text_1');
        const offerText2 = _.get(incentivesDetails, 'offer_text_2');
        const termsText = _.get(incentivesDetails, 'terms_text', intl.formatMessage({ id: `${LOCALE_PREFIX}.terms-text-incentives` }));
        const termsLinkText = _.get(incentivesDetails, 'terms_link_text', intl.formatMessage({ id: `${LOCALE_PREFIX}.terms-details-link-incentives` }));

        return (
            <div className="IncentivesAsideContent">
                <div className="aside-content-incentives">
                    {imgElt && <div className="aside-content-icon">{imgElt}</div>}
                    <div className="aside-content-body">
                        <div className="aside-content-incentive-offer-text-1">
                            <span>{headlineText} {offerText1}</span>
                        </div>
                        <div className="aside-content-incentive-offer-text-2">
                            <span>{offerText2}</span>
                        </div>
                        <TermsText name="installment-terms" termsUrl={_.get(incentivesDetails, 'terms_link')} termsText={termsText} termsLinkText={termsLinkText} />
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(IncentivesAsideContent);
